import type { ReactNode } from 'react';

export type FieldRowProps = {
  label: ReactNode;
  value?: ReactNode;
};

export function FieldRow({ label, value }: FieldRowProps) {
  return (
    <div className="field-row">
      <div className="field-key">{label}</div>
      <div className="field-val">{value ?? <span className="muted">—</span>}</div>
    </div>
  );
}
